import { defineStore } from "pinia";
import { useLocalStorage, useWindowSize } from "@vueuse/core";
import { onMounted } from "vue";

export const useUiStore = defineStore("ui", () => {
  const isSidebarOpen = useLocalStorage("isSidebarOpen", false);
  const { width } = useWindowSize();

  function toggleSidebar() {
    isSidebarOpen.value = !isSidebarOpen.value;
  }

  onMounted(() => {
    if (width.value < 1024 && isSidebarOpen.value) {
      isSidebarOpen.value = false;
    }
  });

  return {
    isSidebarOpen,
    toggleSidebar,
  };
});
